import React from "react";
import css from "./styles.scss";
import { Div, Text3 } from "components/Base";
import CollapsablePanel from "ui-kit/CollapsiblePanel";

const CollapsableWrapper = ({ title, children, headingLeftComp = null }) => (
  <CollapsablePanel
    className={css.collapsablePanelContainer}
    arrowColor="gray7"
    right={false}
    heading={
      <Div display="row.space-between.center" flex={1}>
        <Text3 bold color="gray7" ml={1} style={{ fontWeight: 600 }}>
          {title}
        </Text3>
        {headingLeftComp}
      </Div>
    }
    bg="white"
    opened={true}
    p={2}
    width={1}
    arrowSizeWFS={5}
  >
    {children}
  </CollapsablePanel>
);

export default CollapsableWrapper;
